import { Component } from '@angular/core';

@Component({
    selector: 'app-modal-shell',
    templateUrl: './modal-shell.component.html',
    standalone: false
})
export class ModalShellComponent {

}
